/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'getDrawSystemGameTypeInvoiceByCompositeKey',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_TYPE_INVOICE_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/draw-system-game-type-invoice/:compositeKey',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_TYPE_INVOICE,
    requestSchema: requestSchemas.drawSystemGameTypeInvoices.getDrawSystemGameTypeInvoiceByCompositeKey,
  },
  {
    action: 'printDrawSystemGameTypeInvoiceByCompositeKey',
    message: messages.SUCCESS_PRINT_DRAW_SYSTEM_GAME_TYPE_INVOICE_BY_COMPOSITE_KEY,
    method: 'POST',
    path: '/draw-system-game-type-invoice/:compositeKey/print',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.PRINT_DRAW_SYSTEM_GAME_TYPE_INVOICE,
    requestSchema: requestSchemas.drawSystemGameTypeInvoices.printDrawSystemGameTypeInvoiceByCompositeKey,
  },
  {
    action: 'shareDrawSystemGameTypeInvoiceByCompositeKey',
    message: messages.SUCCESS_SHARE_DRAW_SYSTEM_GAME_TYPE_INVOICE_BY_COMPOSITE_KEY,
    method: 'POST',
    path: '/draw-system-game-type-invoice/:compositeKey/share',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.SHARE_DRAW_SYSTEM_GAME_TYPE_INVOICE,
    requestSchema: requestSchemas.drawSystemGameTypeInvoices.shareDrawSystemGameTypeInvoiceByCompositeKey,
  },
];
